import { ReactNode } from "react";
import { useSamplesDustDensityBaseDataListQuery } from "@/services/backend/samples/api/dust-density-base-data-api";
import { dustDensityBaseDataKey } from "@/services/backend/samples/types/sample-base-data";
import {
  SampleBaseDataListRequest,
  SampleBaseDataTable,
  useSampleBaseDataListRequestWithCompanies,
} from "@/services/backend/samples/components/sample-base-data-table";
import { DeleteDustDensityBaseDataDialog } from "@/services/backend/samples/components/delete-dust-density-base-data-dialog";

export function DustDensityBaseDataTable({
  request,
  onRequestChange,
  renderRowLink,
  hidePagination,
  hideBorder,
}: {
  request: SampleBaseDataListRequest;
  onRequestChange: (request: SampleBaseDataListRequest) => void;
  renderRowLink: (baseDataId: string, children: ReactNode) => ReactNode;
  hidePagination?: boolean;
  hideBorder?: boolean;
}) {
  const { request: effectiveRequest, skip } =
    useSampleBaseDataListRequestWithCompanies(request);
  const { data, isLoading, error } = useSamplesDustDensityBaseDataListQuery(
    effectiveRequest,
    { skip },
  );

  return (
    <SampleBaseDataTable
      data={data}
      isLoading={isLoading}
      error={error}
      dataKey={dustDensityBaseDataKey}
      request={request}
      onRequestChange={onRequestChange}
      renderRowLink={renderRowLink}
      renderDeleteAction={(baseData) => (
        <DeleteDustDensityBaseDataDialog baseData={baseData} />
      )}
      hidePagination={hidePagination}
      hideBorder={hideBorder}
    />
  );
}
